import { useState } from 'react';
import { ToInlineCommaList } from '../../lib/helpers/StringHelper';
import SidePanelSection, { SidePanelSections } from '../../../../components/sidepanel-section';
import { PanelButtons } from '../smartsend/panels/PanelButtons';
import { Tagged } from '../Tagged';
import { P2GText, P2GBox, P2GDivider, P2GLinkGroup, P2GLink } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { displayCurrencySymbol, toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  value: number;
  currency: string;
  title: string;
  updateValue: (v: any) => void;
}

const Conversion: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const setValue = (val: number) => {
    props.updateValue(val);
    setOpen(false);
  };

  const conversions = [
    {
      rate: 0.72,
      currencyCode: 'USD',
      title: 'US Dollars'
    },
    {
      rate: 0.86,
      currencyCode: 'EUR',
      title: 'Euros'
    }
  ];

  if (!props.currency) {
    return null;
  }

  if (props.currency !== 'GBP') {
    return <>{displayCurrencySymbol(props.currency)}</>;
  }

  return (
    <>
      <P2GText onClick={() => setOpen(true)}>
        <u>{displayCurrencySymbol(props.currency)}</u>
      </P2GText>
      <P2GSidePanel open={open} onClose={() => setOpen(false)} title={props.title} anchor="right">
        <Tagged tag="panel-currency">
          <P2GText>
            <Trans
              t={t}
              i18nKey="VALUE_CONVERSION_INTRO_TEXT"
              values={{
                itemValue: toDisplayCurrency(props.currency, props.value),
                currency: props.currency,
                currencyList: ToInlineCommaList(conversions.map((x) => x.title))
              }}
              defaults="Your item value is {{itemValue}} in {{currency}}. If this was
            imported incorrectly you can change it based on the currencies below ({{currencyList}}):"
            />
          </P2GText>
          <P2GBox mt={2} mb={2}>
            <P2GDivider />
          </P2GBox>
          <SidePanelSections>
            <SidePanelSection title={t('VALUE_CONVERSION_SUBTITLE', { defaultValue: 'Value Conversions' })}>
              {conversions.map((c) => (
                <P2GBox mb={1}>
                  <P2GText>
                    <Trans
                      t={t}
                      i18nKey={`CONVERSIONS_SOLD_IN_MESSAGE`}
                      values={{ title: c.title }}
                      defaults="My item was sold in <strong>{{title}}</strong>."
                    />
                  </P2GText>
                  <P2GLinkGroup pt={1}>
                    <P2GLink key="change-to" onClick={() => setValue(props.value * c.rate)}>
                      <Trans
                        t={t}
                        i18nKey={`CURRENCY_CONVERSIONS_CHANGE_TO_LINK`}
                        values={{
                          value: toDisplayCurrency(c.currencyCode, props.value * c.rate)
                        }}
                        defaults="Change to {{value}}"
                      />
                    </P2GLink>
                  </P2GLinkGroup>
                </P2GBox>
              ))}
            </SidePanelSection>
          </SidePanelSections>
          <P2GBox mt={2} />
          <PanelButtons onCancel={() => setOpen(false)} />
        </Tagged>
      </P2GSidePanel>
    </>
  );
};
export default Conversion;
